export const handleTitle = (html) => {
  let result = html;
  const titleList = html.match(/<h[1-6]{1}[^>]*>([\s\S]*?)<\/h[1-6]{1}>/g) || [];
  const contentList = {}; // 记录标题是否重复
  titleList.forEach((titleItem) => {
    const reg = /<h([1-6]{1})[^>]*>([\s\S]*?)<\/h[1-6]{1}>/;
    const titleContent = titleItem.replace(reg, '$2');
    // 有可能匹配到的是这样
    //’我<strong>是</strong>h1<em>斜体</em>介绍‘
    //里面还有标签（直接去掉标签）
    const content = titleContent.replaceAll(/<([\s\S]*?)>|<\/([\s\S]*?)>/g, '');
    let id = content;
    // h标签内容有可能重复的，重复的要做一个索引
    if (contentList[content]) {
      contentList[content] += 1;
      id += `-${contentList[content]}`;
    } else {
      contentList[content] = 1;
    }
    // 补充id和content内容
    result = result.replace(
      titleItem,
      `${titleItem.substring(0, 3)} id="${id}" content="${content}"${titleItem.substring(3)}`,
    );
  });

  return result;
};
